import { caseInsensitiveEqual } from '~/util/string/caseInsensitiveEqual';

import { QuickActionTranslation } from './ConversationQuickAction.types';

const findTranslationByLanguage = (
  translations: QuickActionTranslation[],
  language: string,
): QuickActionTranslation | undefined => {
  return translations.find((translation) => caseInsensitiveEqual(translation.language, language));
};

/**
 * Get the translated text for a specific language, with an optional fallback.
 * @param translations - Array of translation objects.
 * @param language - The target language for the translation.
 * @param fallbackLanguage - An optional fallback language if the target language is not found.
 * @returns The translated text or an empty string if not found.
 */
export const getTranslationText = (
  translations: QuickActionTranslation[],
  language: string,
  fallbackLanguage?: string,
): string => {
  // Try to find translation for the requested language
  const translation = findTranslationByLanguage(translations, language);
  if (translation) {
    return translation.text;
  }

  // Try fallback language if provided
  if (fallbackLanguage) {
    const fallbackTranslation = findTranslationByLanguage(translations, fallbackLanguage);
    if (fallbackTranslation) {
      return fallbackTranslation.text;
    }
  }

  // Return first available translation or empty string
  return translations[0]?.text || '';
};
